module.exports = __webpack_public_path__ + "media/application/images/home/map-ff2a198a1ee7f4a01571b53894d62867.svg";